import { html, customElement } from '@adobe/edex/ui/edex-lit';
import take from 'lodash-es/take';
import { $t } from '@adobe/edex/ui/shared/config/i18n';
import { TagItem } from '@adobe/edex/ui/types';
import { COLLAPSED_TAGS_DISPLAY_COUNT, EdexTagName } from '@adobe/edex/ui/shared/constants';
import { I18nKey } from '@adobe/edex/ui/shared/constants/i18n';
import { BaseElement } from '@adobe/edex/ui/components/base.element';
import { navigate } from '@adobe/edex/ui/config/router';

import(
  /* webpackChunkName: "component/tags-element-styles" */
  /* webpackMode: "lazy" */
  '@adobe/edex/ui/components/shared/tags/tags.scss'
);

const Tag = ({ label, url }: TagItem) => {
  return html`
    <sp-tag
      @keyup=${(e: KeyboardEvent) => {
        switch (e.key.toLowerCase()) {
          case 'enter':
            (e.currentTarget as HTMLElement).click();
            break;
          default:
            break;
        }
      }}
      @click=${(e) => {
        const a = e.currentTarget.querySelector('a');
        if (e.target.closest('a') !== a) {
          a.click();
        }
      }}
    >
      <a href="${url}" tabindex="-1">${$t(label)}</a>
    </sp-tag>
  `;
};

@customElement(EdexTagName.tags)
export class Tags extends BaseElement {
  get useLightDom() {
    return true;
  }

  static get properties() {
    return {
      items: { type: Array },
      header: { type: String },
      viewMore: { type: Boolean },
      isCollapsed: { type: Boolean },
      isCollapsible: { type: Boolean },
      collapsedDisplayCount: { type: Number },
    };
  }
  items: TagItem[];
  header: string;
  isCollapsed = true;
  isCollapsible = true;
  collapsedDisplayCount = COLLAPSED_TAGS_DISPLAY_COUNT;

  handleViewMoreClick() {
    this.isCollapsed = !this.isCollapsed;
  }

  render() {
    const { items, header, isCollapsible, isCollapsed, collapsedDisplayCount } = this;
    const limit = isCollapsible && isCollapsed ? collapsedDisplayCount : items.length;
    const showViewMore = isCollapsible && items.length > collapsedDisplayCount;

    return html`
      <div class="tags">
        ${header
          ? html`
              <h2 class="tags-header">${header}</h2>
            `
          : ''}
        <sp-tags>
          ${take(items, limit).map(Tag)}
          ${showViewMore
            ? html`
                <sp-button quiet variant="secondary" @click="${this.handleViewMoreClick}">
                  ${isCollapsed ? $t(I18nKey.viewMore) : $t(I18nKey.viewLess)}
                </sp-button>
              `
            : ''}
        </sp-tags>
      </div>
    `;
  }
}
